import React from "react";
import { useRevalidator } from "react-router-dom";
import { IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import AddRoleDialog from "../utils/AddRoleDialog";

/// button to open a create or update resource form in a dialog
const AddRoleButton: React.FC<{
    userSubId: number;
}> = ({ userSubId }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const revalidator = useRevalidator();

    return (
        <>
            <IconButton
                onClick={() => {
                    setDialogOpen(true);
                }}
                sx={{
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    "&:hover": {
                        bgcolor: "primary.dark",
                    },
                }}
            >
                <FontAwesomeIcon icon={faPlus} />
            </IconButton>
            <AddRoleDialog
                userSubId={dialogOpen ? userSubId : null}
                visible={dialogOpen}
                onHide={(changed) => {
                    if (changed) revalidator.revalidate();
                    setDialogOpen(false);
                }}
            />
        </>
    );
};

export default AddRoleButton;
